import Component from './src/Component.vue'
export default Component
